import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import star_yell from "../../assets/icon/star_yell.svg";
import star_default from "../../assets/icon/star_gray.svg";
import { useLanguage } from '../../hooks/useLanguage';

function EquipmentRatingPopup({ isPopup, setIsPopup }){
  const { t } = useLanguage();
  const location = useLocation();
  const [popupActive, setPopupActive] = useState(false);

  useEffect(() => {
      const body = document.body;
      body.style.overflow = isPopup ? 'hidden' : 'auto';
      return () => {
          body.style.overflow = 'auto';
      };
  }, [isPopup]);

  useEffect(() => {
      let timeout;
      if (isPopup) {
          timeout = setTimeout(() => {
              setPopupActive(true);
          }, 100);
      } else {
          setPopupActive(false);
      }
      return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
      document.body.style.overflow = 'auto';
  }, [location]);

  const handleClose = (e) => {
    e.preventDefault();
    setIsPopup(false);  // 팝업만 닫기
  };

  // 딤 배경 클릭 핸들러 추가
  const handleBackgroundClick = (e) => {
    // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };
  

  if (isPopup)
    return (
        <div 
          className="popup-box-component"
          onClick={handleBackgroundClick}
        >
          <div className={`box content ${popupActive ? 'active' : ''}`}>
            <div className="popup_container">
              <h4 className="pop_title line">{t('equipment_rating')}</h4>
              <div className='close_btn_con'>
                <button 
                  type="button" 
                  className="close_btn"
                  onClick={handleClose}
                />
              </div>
              <div className="pop_addr_con scroll_custom pd_b16">
                <p className="pad_b p3_1">{t('equipment_return_point')}</p>
                <ul className="equip_list column flex-16">
                  <li className="info_item">
                    <div className="equp_con"> 
                      <div className="strong_b2 flex-btw">
                        <h4>{t('equipment_return_point2', {count: 5})}</h4>
                        <ul className='rating_list'>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_default} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_default} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_default} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_default} alt="star" loading="lazy"/>
                          </li>
                        </ul>
                      </div>  
                      <p className="b1_2 g-90">{t('equipment_return_point3')}<br/> {t('equipment_return_point4')}</p>
                    </div>
                  </li>

                  <li className="info_item">
                    <div className="equp_con"> 
                      <div className="strong_b2 flex-btw">
                        <h4>{t('equipment_return_point2', {count: 6})}</h4>
                        <ul className='rating_list'>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_default} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_default} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_default} alt="star" loading="lazy"/>
                          </li>
                        </ul>
                      </div>  
                      <p className="b1_2 g-90">{t('equipment_return_point5')}</p>
                    </div>
                  </li>

                  <li className="info_item">
                    <div className="equp_con"> 
                      <div className="strong_b2 flex-btw">
                        <h4>{t('equipment_return_point2', {count: 7})}</h4>
                        <ul className='rating_list'>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_default} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_default} alt="star" loading="lazy"/>
                          </li>
                        </ul>
                      </div>  
                      <p className="b1_2 g-90">{t('equipment_return_point6')}<br/> {t('equipment_return_point7')}</p>
                    </div>
                  </li>

                  <li className="info_item">
                    <div className="equp_con"> 
                      <div className="strong_b2 flex-btw">
                        <h4>{t('equipment_return_point2', {count: 9})}</h4>
                        <ul className='rating_list'>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_default} alt="star" loading="lazy"/>
                          </li>
                        </ul>
                      </div>  
                      <p className="b1_2 g-90">{t('equipment_return_point8')}<br/> {t('equipment_return_point9')}</p>
                    </div>
                  </li>

                  <li className="info_item">
                    <div className="equp_con"> 
                      <div className="strong_b2 flex-btw">
                        <h4>{t('equipment_return_point2', {count: 10})}</h4>
                        <ul className='rating_list'>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                          <li>
                            <img src={star_yell} alt="star" loading="lazy"/>
                          </li>
                        </ul>
                      </div>  
                      <p className="b1_2 g-90">{t('equipment_return_point10')}<br/> {t('equipment_return_point11')}</p>
                    </div>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
    );
};

export default EquipmentRatingPopup;